import React, { useState } from 'react';
import ADEEL from "../Assets/bhatti22.PNG";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaUser, FaFileAlt, FaImage, FaServer, FaEnvelope } from 'react-icons/fa';
import { HiHome } from 'react-icons/hi';

import {
  faTwitter,
  faFacebookF,
  faInstagram,
  faSkype,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';

const LeftPage1 = () => {
  const [open, setOpen] = useState(false);

  const menuItems = [
    { name: 'Home', icon: <HiHome />,link: '#home', active: true },
    { name: 'About', icon: <FaUser />,link: '#about' },
    { name: 'Resume', icon: <FaFileAlt />,link: '#Resume'},
    { name: 'Services', icon: <FaImage />,link: '#Services'},
    { name: 'Projects', icon: <FaServer />,link: '#Projects' },
    { name: 'Contact', icon: <FaEnvelope />,link: '#Contact' },
  ];

  const icons = [
    { icon: faTwitter, link: '#', hover: 'hover:bg-blue-700' },
    { icon: faFacebookF, link: '#', hover: 'hover:bg-blue-600' },
    { icon: faInstagram, link: '#', hover: 'hover:bg-pink-600' },
    { icon: faSkype, link: '#', hover: 'hover:bg-blue-400' },
    { icon: faLinkedinIn, link: '#', hover: 'hover:bg-blue-700' },
  ];

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        className="md:hidden fixed top-5 right-5 z-50  bg-blue-500 text-white px-4 py-3 rounded-full"
        onClick={() => setOpen(!open)}
      >
        ☰
      </button>

      {/* Sidebar Container */}
      <div className={`fixed top-0 left-0 h-full w-[290px] bg-slate-900 z-50 overflow-hidden transform transition-transform duration-300 
        ${open ? "translate-x-0" : "-translate-x-full"} md:relative  md:translate-x-0`}>

        {/* Profile Section */}
        <div className="flex items-center justify-center pt-8">
          <img
            src={ADEEL}
            alt="Profile"
            className="w-32 h-32 object-cover rounded-full border-4 border-white"
          />
        </div>
        <p className="text-lg text-white text-center pt-4">TALAL HAIDER</p>

        {/* Social Icons */}
        <div className="flex items-center justify-center gap-2 py-6">
          {icons.map((item, index) => (
            <a
              key={index}
              href={item.link}
              className={`w-10 h-10 bg-[#1e1f25] text-white rounded-full flex items-center justify-center transition duration-300 ${item.hover}`}
            >
              <FontAwesomeIcon icon={item.icon} size="lg" />
            </a>
          ))}
        </div>

        {/* Navigation Menu */}
        <div className="flex flex-col p-6 space-y-6">
          {menuItems.map((item, index) => (
              <a
      key={index}
      href={item.link || '#'}
      onClick={(e) => {
        e.preventDefault(); // Prevent instant jump
        const targetId = item.link?.replace('#', '');
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }}
              className={`flex items-center space-x-3 cursor-pointer 
                ${item.active ? 'text-blue-500 font-semibold' : 'text-white hover:text-blue-400'}`}
            >
              <div className="text-xl">{item.icon}</div>
              <span>{item.name}</span>
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default LeftPage1;

